import { render } from "./rz.vue?vue&type=template&id=2acf0a9a&scoped=true"
import script from "./rz.vue?vue&type=script&lang=js"
export * from "./rz.vue?vue&type=script&lang=js"

import "./rz.vue?vue&type=style&index=0&id=2acf0a9a&scoped=true&lang=scss"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acf0a9a"]])

export default __exports__